import { BRAND } from './brand';
import { SUBSCRIPTION_PRODUCTS } from './subscription';
import type { Plan, PlanId } from '@/types';

export const PLANS: Readonly<Record<PlanId, Plan>> = {
  free: {
    id: 'free',
    name: 'Free',
    tagline: 'Everything you need to send your first quote today.',
    limits: { savedCustomers: 3, savedServices: null, savedQuotes: null },
    capabilities: {
      removeBranding: false, customLogoOnPdf: true, premiumPdfThemes: false, customBranding: false,
    },
    highlights: [
      'Unlimited quotes',
      '3 saved customers',
      'Full business profile',
      'Your logo on every quote',
      `${BRAND.name} footer on the PDF`,
    ],
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    tagline: 'For businesses quoting every day.',
    limits: { savedCustomers: null, savedServices: null, savedQuotes: null },
    capabilities: {
      removeBranding: true, customLogoOnPdf: true, premiumPdfThemes: true, customBranding: true,
    },
    /**
     * Which Dodo product each cycle is. The price is not here: it is read from
     * Dodo at request time — see `config/subscription.ts`.
     */
    pricing: SUBSCRIPTION_PRODUCTS,
    highlights: [
      'Unlimited customers',
      'Unlimited quotes & services',
      `No ${BRAND.name} footer`,
      'Premium PDF themes',
      'Full custom branding',
    ],
  },
} as const;

export const DEFAULT_PLAN: PlanId = 'free';

/**
 * The plan for a stored id, and Free for anything else. The id is a cached
 * server answer in local storage; a missing, stale or hand-edited value must
 * never be the reason a quote cannot be drawn. `Object.hasOwn`, so `toString`
 * and friends are not plans either.
 */
export function resolvePlan(id: unknown): Plan {
  return typeof id === 'string' && Object.hasOwn(PLANS, id) ? PLANS[id as PlanId] : PLANS[DEFAULT_PLAN];
}
